var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNavLine = function SvgNavLine(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76 7.12v1.84h5.44v-3.68h-5.44v1.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 7.12v1.84h21.44v-3.68h-21.44v1.84z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76 16v1.92h5.44v-3.84h-5.44v1.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 16v1.92h21.44v-3.84h-21.44v1.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76 24.88v1.84h5.44v-3.68h-5.44v1.84z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 24.88v1.84h21.44v-3.68h-21.44v1.84z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-line.87f8928a.svg";
export { ForwardRef as ReactComponent };